import React, { useState } from 'react';
import { ArrowLeft, Upload, Check, ChevronRight, MapPin, Shield, Zap, Building, FileText, Camera } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
export function CreateListingPage() {
  const [step, setStep] = useState(1);
  const totalSteps = 7;
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-3612">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6" data-id="element-3613">
        <div className="max-w-4xl mx-auto flex items-center justify-between" data-id="element-3614">
          <Link to="/" className="flex items-center gap-2" data-id="element-3615">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-3616"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-3617">
              Citiplots.com
            </span>
          </Link>
          <div className="font-bold text-lg" data-id="element-3618">Create New Listing</div>
          <Link to="/dashboard/seller" className="flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-3619">
            <ArrowLeft className="w-4 h-4" data-id="element-3620" /> Exit
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-4xl mx-auto px-6 py-12" data-id="element-3621">
        {/* Progress Bar */}
        <div className="mb-12" data-id="element-3622">
          <div className="flex justify-between mb-2 text-sm font-mono text-gray-500" data-id="element-3623">
            <span data-id="element-3624">
              Step {step} of {totalSteps}
            </span>
            <span data-id="element-3625">{Math.round(step / totalSteps * 100)}% Complete</span>
          </div>
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-3626">
            <div className="h-full bg-[#1f2933] transition-all duration-300" style={{
            width: `${step / totalSteps * 100}%`
          }} data-id="element-3627"></div>
          </div>
        </div>

        <div className="bg-white border border-gray-300 p-8 md:p-12 shadow-sm" data-id="element-3628">
          {/* Step 1: Basic Details */}
          {step === 1 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3629">
              <div data-id="element-3630">
                <h1 className="text-2xl font-bold mb-2" data-id="element-3631">Basic Plot Details</h1>
                <p className="text-gray-500" data-id="element-3632">
                  Start with the core information about your land parcel.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3633">
                <div className="space-y-2" data-id="element-3634">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3635">
                    Listing Title
                  </label>
                  <input type="text" placeholder="e.g. 2000 Sqft Plot in Baner" className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3636" />
                </div>
                <div className="space-y-2" data-id="element-3637">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3638">
                    Price (₹)
                  </label>
                  <input type="text" placeholder="e.g. 45,00,000" className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3639" />
                </div>
                <div className="space-y-2" data-id="element-3640">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3641">
                    Plot Area (Sq. Ft)
                  </label>
                  <input type="number" placeholder="e.g. 2400" className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3642" />
                </div>
                <div className="space-y-2" data-id="element-3643">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3644">
                    Listing Type
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3645">
                    <option data-id="element-3646">Sell</option>
                    <option data-id="element-3647">Rent / Lease</option>
                  </select>
                </div>
              </div>
            </div>}

          {/* Step 2: Location & Measurements */}
          {step === 2 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3648">
              <div data-id="element-3649">
                <h1 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-3650">
                  <MapPin className="w-6 h-6" data-id="element-3651" /> Location & Measurements
                </h1>
                <p className="text-gray-500" data-id="element-3652">
                  Precise location helps buyers find your plot easily.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3653">
                <div className="space-y-2 md:col-span-2" data-id="element-3654">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3655">
                    Full Address
                  </label>
                  <textarea placeholder="Enter full address with landmarks..." className="w-full p-3 border border-gray-300 bg-gray-50 h-24 focus:outline-none focus:border-[#1f2933]" data-id="element-3656"></textarea>
                </div>
                <div className="space-y-2" data-id="element-3657">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3658">
                    Survey / Gat No.
                  </label>
                  <input type="text" placeholder="e.g. 45/2/A" className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3659" />
                </div>
                <div className="space-y-2" data-id="element-3660">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3661">
                    PIN Code
                  </label>
                  <input type="text" placeholder="e.g. 411057" className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3662" />
                </div>
                <div className="space-y-2" data-id="element-3663">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3664">
                    Dimensions (L x W ft)
                  </label>
                  <div className="flex gap-2" data-id="element-3665">
                    <input type="number" placeholder="Length" className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3666" />
                    <span className="self-center" data-id="element-3667">x</span>
                    <input type="number" placeholder="Width" className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3668" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-3669">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3670">
                    Boundary Wall
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3671">
                    <option data-id="element-3672">Present (Complete)</option>
                    <option data-id="element-3673">Partial</option>
                    <option data-id="element-3674">Fencing Only</option>
                    <option data-id="element-3675">None</option>
                  </select>
                </div>
              </div>
            </div>}

          {/* Step 3: Legal & Title */}
          {step === 3 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3676">
              <div data-id="element-3677">
                <h1 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-3678">
                  <Shield className="w-6 h-6" data-id="element-3679" /> Legal & Title
                </h1>
                <p className="text-gray-500" data-id="element-3680">
                  Clear title details increase buyer confidence significantly.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3681">
                <div className="space-y-2" data-id="element-3682">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3683">
                    Ownership Type
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3684">
                    <option data-id="element-3685">Freehold</option>
                    <option data-id="element-3686">Leasehold</option>
                    <option data-id="element-3687">Co-operative Society</option>
                    <option data-id="element-3688">Power of Attorney (GPA)</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-3689">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3690">
                    Seller Type
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3691">
                    <option data-id="element-3692">Individual Owner</option>
                    <option data-id="element-3693">Developer / Builder</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-3694">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3695">
                    Any Existing Loan?
                  </label>
                  <div className="flex gap-4 mt-2" data-id="element-3696">
                    <label className="flex items-center gap-2" data-id="element-3697">
                      <input type="radio" name="loan" className="accent-[#1f2933]" data-id="element-3698" />{' '}
                      Yes
                    </label>
                    <label className="flex items-center gap-2" data-id="element-3699">
                      <input type="radio" name="loan" className="accent-[#1f2933]" defaultChecked data-id="element-3700" />{' '}
                      No
                    </label>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-3701">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3702">
                    Litigation Status
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3703">
                    <option data-id="element-3704">No Litigation (Clear)</option>
                    <option data-id="element-3705">Dispute Resolved</option>
                    <option data-id="element-3706">Case Pending</option>
                  </select>
                </div>
              </div>
            </div>}

          {/* Step 4: Attributes & Utilities */}
          {step === 4 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3707">
              <div data-id="element-3708">
                <h1 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-3709">
                  <Zap className="w-6 h-6" data-id="element-3710" /> Infrastructure & Utilities
                </h1>
                <p className="text-gray-500" data-id="element-3711">
                  What facilities are available on or near the plot?
                </p>
              </div>

              <div className="space-y-6" data-id="element-3712">
                <div data-id="element-3713">
                  <label className="block text-sm font-bold text-gray-700 mb-3" data-id="element-3714">
                    Road Access
                  </label>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3715">
                    <div className="space-y-2" data-id="element-3716">
                      <span className="text-xs text-gray-500" data-id="element-3717">Road Type</span>
                      <select className="w-full p-2 border border-gray-300 bg-gray-50" data-id="element-3718">
                        <option data-id="element-3719">Tar / Asphalt</option>
                        <option data-id="element-3720">Concrete</option>
                        <option data-id="element-3721">WBM / Mud</option>
                      </select>
                    </div>
                    <div className="space-y-2" data-id="element-3722">
                      <span className="text-xs text-gray-500" data-id="element-3723">
                        Road Width (ft)
                      </span>
                      <input type="number" className="w-full p-2 border border-gray-300 bg-gray-50" placeholder="e.g. 40" data-id="element-3724" />
                    </div>
                  </div>
                </div>

                <div data-id="element-3725">
                  <label className="block text-sm font-bold text-gray-700 mb-3" data-id="element-3726">
                    Available Utilities
                  </label>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-3727">
                    {['Electricity', 'Municipal Water', 'Borewell', 'Sewage Line', 'Gas Pipeline', 'Street Lights'].map(item => <label key={item} className="flex items-center gap-2 p-3 border border-gray-200 cursor-pointer hover:bg-gray-50" data-id="element-3728">
                        <input type="checkbox" className="accent-[#1f2933]" data-id="element-3729" />
                        <span className="text-sm" data-id="element-3730">{item}</span>
                      </label>)}
                  </div>
                </div>
              </div>
            </div>}

          {/* Step 5: Zoning & Development */}
          {step === 5 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3731">
              <div data-id="element-3732">
                <h1 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-3733">
                  <Building className="w-6 h-6" data-id="element-3734" /> Zoning & Development
                </h1>
                <p className="text-gray-500" data-id="element-3735">
                  Define what can be built on this land.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3736">
                <div className="space-y-2" data-id="element-3737">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3738">
                    Current Land Use
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3739">
                    <option data-id="element-3740">Residential</option>
                    <option data-id="element-3741">Commercial</option>
                    <option data-id="element-3742">Agricultural</option>
                    <option data-id="element-3743">Industrial</option>
                    <option data-id="element-3744">Mixed Use</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-3745">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3746">
                    Zone Type
                  </label>
                  <input type="text" placeholder="e.g. R-1, R-2" className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3747" />
                </div>
                <div className="space-y-2" data-id="element-3748">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3749">
                    FSI / FAR Allowed
                  </label>
                  <input type="text" placeholder="e.g. 1.5" className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3750" />
                </div>
                <div className="space-y-2" data-id="element-3751">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3752">
                    NA Conversion Status
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3753">
                    <option data-id="element-3754">NA Order Received</option>
                    <option data-id="element-3755">In Process</option>
                    <option data-id="element-3756">Not Applied</option>
                    <option data-id="element-3757">Not Applicable (Gaothan)</option>
                  </select>
                </div>
              </div>
            </div>}

          {/* Step 6: Media & Documents */}
          {step === 6 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3758">
              <div data-id="element-3759">
                <h1 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-3760">
                  <Camera className="w-6 h-6" data-id="element-3761" /> Media & Documents
                </h1>
                <p className="text-gray-500" data-id="element-3762">
                  Visuals and proof documents attract serious buyers.
                </p>
              </div>

              <div className="space-y-6" data-id="element-3763">
                <div className="border border-dashed border-gray-300 p-8 bg-gray-50 text-center" data-id="element-3764">
                  <Upload className="w-8 h-8 mx-auto text-gray-400 mb-2" data-id="element-3765" />
                  <h3 className="font-bold text-sm" data-id="element-3766">Upload Plot Photos</h3>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-3767">
                    Drag & drop or click to browse (Max 10 images)
                  </p>
                </div>

                <div data-id="element-3768">
                  <h3 className="font-bold text-sm mb-3" data-id="element-3769">Required Documents</h3>
                  <div className="space-y-3" data-id="element-3770">
                    {['7/12 Extract or Sale Deed', 'NA Order Copy', 'Latest Tax Receipt'].map((doc, i) => <div key={i} className="flex items-center justify-between p-3 border border-gray-200 bg-white" data-id="element-3771">
                        <span className="text-sm" data-id="element-3772">{doc}</span>
                        <button className="text-xs font-bold text-blue-600 border border-blue-200 px-3 py-1 rounded hover:bg-blue-50" data-id="element-3773">
                          Upload
                        </button>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>}

          {/* Step 7: Preview */}
          {step === 7 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3774">
              <div data-id="element-3775">
                <h1 className="text-2xl font-bold mb-2" data-id="element-3776">Review & Publish</h1>
                <p className="text-gray-500" data-id="element-3777">
                  Double check all details before going live.
                </p>
              </div>

              <div className="border border-gray-300 p-6 bg-gray-50 space-y-6" data-id="element-3778">
                <div className="flex justify-between border-b border-gray-200 pb-4" data-id="element-3779">
                  <div data-id="element-3780">
                    <h3 className="font-bold text-lg" data-id="element-3781">
                      2000 Sqft Plot in Baner
                    </h3>
                    <p className="text-gray-500" data-id="element-3782">Pune, Maharashtra</p>
                  </div>
                  <div className="text-right" data-id="element-3783">
                    <div className="font-bold text-lg" data-id="element-3784">₹ 45,00,000</div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-3785">
                  <div data-id="element-3786">
                    <span className="text-gray-500 block" data-id="element-3787">Area</span>
                    <span className="font-bold" data-id="element-3788">2,400 Sq. Ft</span>
                  </div>
                  <div data-id="element-3789">
                    <span className="text-gray-500 block" data-id="element-3790">Zoning</span>
                    <span className="font-bold" data-id="element-3791">Residential (R-1)</span>
                  </div>
                  <div data-id="element-3792">
                    <span className="text-gray-500 block" data-id="element-3793">Ownership</span>
                    <span className="font-bold" data-id="element-3794">Freehold</span>
                  </div>
                  <div data-id="element-3795">
                    <span className="text-gray-500 block" data-id="element-3796">Documents</span>
                    <span className="font-bold text-green-600" data-id="element-3797">3 Uploaded</span>
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-3798">
                <button className="flex-1 py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-3799">
                  Publish Listing
                </button>
                <button className="flex-1 py-3 border border-gray-300 font-bold hover:bg-gray-50" data-id="element-3800">
                  Save Draft
                </button>
              </div>
            </div>}

          {/* Navigation Buttons */}
          {step < 7 && <div className="flex justify-between mt-12 pt-6 border-t border-gray-200" data-id="element-3801">
              <button onClick={() => setStep(Math.max(1, step - 1))} disabled={step === 1} className={`px-6 py-3 font-bold text-sm ${step === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-3802">
                Back
              </button>
              <button onClick={() => setStep(Math.min(7, step + 1))} className="flex items-center gap-2 px-8 py-3 bg-[#1f2933] text-white font-bold text-sm hover:bg-gray-800" data-id="element-3803">
                Continue <ChevronRight className="w-4 h-4" data-id="element-3804" />
              </button>
            </div>}
        </div>
      </main>

      <Footer data-id="element-3805" />
    </div>;
}